import {
  MethodKey,
  Questionnaire,
  WeightLossKeys,
  WeightLossRenewalKeys,
  WeightLossTwoKeys,
} from '~/types/models/questionnaire';
import doctor1 from '~/assets/images/doctor-1.png';
import doctor2 from '~/assets/images/doctor-2.png';
import doctor3 from '~/assets/images/doctor-3.png';
import howItWorks1 from '~/assets/images/how-it-works-1.png';
import howItWorks2 from '~/assets/images/how-it-works-2.png';
import howItWorks3 from '~/assets/images/how-it-works-3.png';
import howItWorks4 from '~/assets/images/how-it-works-4.png';
import glp1 from '~/assets/images/glp1.png';
import pillProgram from '~/assets/images/pill-program.png';
import cgm from '~/assets/images/cgm.png';
import supplement from '~/assets/images/supplement.png';
import {DropdownOptions} from '~/types/general';
import saxenda from '~/assets/images/saxenda.png';
import rybelsus from '~/assets/images/rybelsus.png';
import panbesy from '~/assets/images/panbesy.png';

import callIcon from '~/assets/images/call-icon.png';
import deliveryIcon from '~/assets/images/delivery-icon.png';
import needleIcon from '~/assets/images/needle-icon.png';
import mdqReview from '~/assets/images/mdq-review.png';
import doctorTel from '~/assets/images/doctor-tel.png';

import bakedChessyPasta from '~/assets/images/baked-chessy-pasta.png';
import briyaniChicken from '~/assets/images/briyani-chicken.png';
import kimchiFriedRice from '~/assets/images/kimchi-fried-rice.png';
import rosemaryChicken from '~/assets/images/rosemary-chicken.png';
import tomyumPasta from '~/assets/images/tomyum-pasta.png';
import basilChickenRice from '~/assets/images/basil-chicken-rice.png';
import bolognese from '~/assets/images/bolognese.png';
import charKwayTeow from '~/assets/images/char-kway-teow.png';
import chickenBarChorMee from '~/assets/images/chicken-bar-chor-mee.png';
import chickenWithMash from '~/assets/images/chicken-with-mash.png';
import claypotChickenRice from '~/assets/images/claypot-chicken-rice.png';
import cottagePie from '~/assets/images/cottage-pie.png';
import friedCauliflower from '~/assets/images/fried-cauliflower.png';
import koreanJapchae from '~/assets/images/korean-japchae.png';
import mushroomChickenPasta from '~/assets/images/mushroom-chicken-pasta.png';
import oliveRice from '~/assets/images/olive-rice.png';
import padThai from '~/assets/images/pad-thai.png';
import shinemji from '~/assets/images/shinemji.png';
import sambalFriedRice from '~/assets/images/sambal-fried-rice.png';
import tomYumSpaghetti from '~/assets/images/tom-yum-spaghetti.png';

export const NONE_VALUE = 'NONE';
export const AT_HOME = 'AT_HOME';
export const PROGRAM_TYPE = {
  MEDICATION: 'medication',
  PROGRAM: 'program',
};

export const PRODUCT_SKUS = {
  DOCTOR_TEL: 'SG-TEL-WL-1',
  NOVOFINE_NEEDLES: 'SG-P-WLM-SAX-CON',
  TEL_GLP1: 'SG-TEL-GLP',
  TEL_PILL: 'SG-TEL-PIL',
};

export const ELEVATE_LINK = 'https://tryelevate.sg/';

export const BMI_THRESHOLD = {
  UNDERWEIGHT: 18.5,
  HEALTHY: 27.0,
};

export const LET_DOCTOR_DECIDE_THRESHOLD = 25.5;

export const PROGRESS_DATA = [
  {
    label: 'Evaluation',
    value: 1,
  },
  {
    label: 'Selection',
    value: 2,
  },
  {
    label: 'Checkout',
    value: 3,
  },
];

export const SEX_VALUES = {
  female: 'Female',
  male: 'Male',
  nonBinary: 'Non-binary',
};

export const SEX_OPTIONS: DropdownOptions = [
  {
    label: 'Female',
    value: SEX_VALUES.female,
  },
  {
    label: 'Male',
    value: SEX_VALUES.male,
  },
  {label: 'Non-binary', value: SEX_VALUES.nonBinary},
];

export const PHOTO_ID_TYPE_VALUES = {
  NRIC: 'NRIC',
  passport: 'Passport',
};

export const ID_TYPE_OPTIONS: DropdownOptions = [
  {
    label: 'NRIC',
    value: PHOTO_ID_TYPE_VALUES.NRIC,
  },
  {
    label: 'Passport',
    value: PHOTO_ID_TYPE_VALUES.passport,
  },
];

export const YES_NO_VALUES = {
  YES: 'YES',
  NO: 'NO',
};

export const WL_PROGRAMS = {
  ELEVATE_GLP_1_PROGRAM: {
    value: 'removed',
    localValue: 'removed',
    label: 'Elevate GLP-1 Program',
    title: 'GLP-1',
    goalName: 'the Elevate GLP-1 Program',
  },
  ELEVATE_PILL_PROGRAM: {
    value: 'removed',
    localValue: 'removed',
    label: 'Elevate Pill Program',
    title: 'Pill',
    goalName: 'the Elevate Pill Program',
  },
  ELEVATE_CGM_PROGRAM: {
    value: 'wl_teleconsultation_cgm',
    localValue: 'wl_teleconsultation_cgm',
    label: 'Elevate CGM Program',
    title: 'CGM',
    goalName: 'the Elevate CGM Program',
  },
  ELEVATE_SUPPLEMENT_PROGRAM: {
    value: 'supplement_program',
    localValue: 'supplement_program',
    label: 'Elevate Supplement Program',
    title: 'Supplement',
    goalName: 'the Elevate Supplement Program',
  },
  ELEVATE_SAXENDA: {
    value: 'wl_teleconsultation_glp1',
    localValue: 'wl_teleconsultation_glp1',
    label: 'Liraglutide (Saxenda)',
    title: 'Saxenda',
    goalName: 'Saxenda',
  },
  ELEVATE_RYBELSUS: {
    value: 'wl_teleconsultation_pill',
    localValue: 'wl_rybelsus',
    label: 'Semaglutide (Rybelsus) pill',
    title: 'Rybelsus',
    goalName: 'Rybelsus',
  },
  ELEVATE_PANBESY: {
    value: 'wl_teleconsultation_pill',
    localValue: 'wl_panbesy',
    label: 'Phentermine (Panbesy) pill',
    title: 'Panbesy',
    goalName: 'Panbesy',
  },
  LET_DOCTOR_DECIDE: {
    value: 'doctor_teleconsultation_wl',
    localValue: 'doctor_teleconsultation_wl',
    label: 'Let the doctor decide',
    title: 'Let the doctor decide',
    goalName: 'Let the doctor decide',
  },
  ELEVATE_NUTRITION_PROGRAM: {
    value: 'elevate_nutrition_program',
    localValue: 'elevate_nutrition_program',
    label: 'Elevate Nutrition Program',
    title: 'Nutrition Program',
    goalName: 'the Elevate Nutrition Program',
  },
};

export const SYMPTOM_BLOCK_NAMES = {
  [WL_PROGRAMS.ELEVATE_SAXENDA.localValue]: 'Saxenda',
  [WL_PROGRAMS.ELEVATE_RYBELSUS.localValue]: 'Semaglutide',
};

export const WL_PRODUCT_SKU: Record<string, string> = {
  wl_teleconsultation_glp1: 'SG-TEL-GLP',
  wl_teleconsultation_pill: 'SG-TEL-PIL',
  supplement_program: 'SG-TEL-PHAR',
};

export const METHOD_KEYS: Record<MethodKey, MethodKey> = {
  WEIGHT_LOSS_PROGRAM: 'WEIGHT_LOSS_PROGRAM',
  WEIGHT_LOSS_PROGRAM_TWO: 'WEIGHT_LOSS_PROGRAM_TWO',
  MDQ2: 'MDQ2',
  MDQ_RENEWAL: 'MDQ_RENEWAL',
};

export const WEIGHT_LOSS_KEYS: Record<WeightLossKeys, WeightLossKeys> = {
  START: 'START',
  HOW_IT_WORK: 'HOW_IT_WORK',
  PROFILE: 'PROFILE',
  INVALID: 'INVALID',
  HOW_DID_YOU_HEAR_ABOUT_US: 'HOW_DID_YOU_HEAR_ABOUT_US',
  IMPORTANT_INFORMATION: 'IMPORTANT_INFORMATION',
  ABOUT_SAXENDA: 'ABOUT_SAXENDA',
  HOW_WEIGHT_LOSS_PROGRAM_WORKS: 'HOW_WEIGHT_LOSS_PROGRAM_WORKS',
  BMI_CALCULATOR: 'BMI_CALCULATOR',
  PROGRAM_SELECTION: 'PROGRAM_SELECTION',
  BMI_UNDERWEIGHT: 'BMI_UNDERWEIGHT',
  BMI_HEALTHY_BLOCK: 'BMI_HEALTHY_BLOCK',
  BMI_HEALTHY_NEXT: 'BMI_HEALTHY_NEXT',
  BMI_OVERWEIGHT: 'BMI_OVERWEIGHT',
  BMI_ALLERGIC: 'BMI_ALLERGIC',
  OBESITY_RELATED_CONDITIONS: 'OBESITY_RELATED_CONDITIONS',
  FOLLOWING_APPLY: 'FOLLOWING_APPLY',
  COULD_WORK_FOR_YOU: 'COULD_WORK_FOR_YOU',
  COULD_WORK_FOR_YOU_GLP: 'COULD_WORK_FOR_YOU_GLP',
  COULD_WORK_FOR_YOU_PILL: 'COULD_WORK_FOR_YOU_PILL',
  COULD_WORK_FOR_YOU_CGM: 'COULD_WORK_FOR_YOU_CGM',
  COULD_WORK_FOR_YOU_SUPPLEMENTS: 'COULD_WORK_FOR_YOU_SUPPLEMENTS',
  COULD_WORK_FOR_YOU_SAXENDA: 'COULD_WORK_FOR_YOU_SAXENDA',
  NUTRITION_HOW_IT_WORKS: 'NUTRITION_HOW_IT_WORKS',
  NUTRITION_WHAT_INCLUDED: 'NUTRITION_WHAT_INCLUDED',
  ELEVATE_PROGRAM_GOALS: 'ELEVATE_PROGRAM_GOALS',
  CGM_PACKAGE_SELECTION: 'CGM_PACKAGE_SELECTION',
  SAXENDA_PACKAGE_SELECTION: 'SAXENDA_PACKAGE_SELECTION',
  NUTRITION_PACKAGE_SELECTION: 'NUTRITION_PACKAGE_SELECTION',
  DO_YOU_NEED_NEEDLES: 'DO_YOU_NEED_NEEDLES',
  WHATS_NEXT_SAXENDA: 'WHATS_NEXT_SAXENDA',
  WHATS_NEXT_RYBELSUS: 'WHATS_NEXT_RYBELSUS',
  WHATS_NEXT_PANBESY: 'WHATS_NEXT_PANBESY',
  CGM_ADD_ON_SELECTION: 'CGM_ADD_ON_SELECTION',
  DESCRIBE_CURRENT_LIFESTYLE: 'DESCRIBE_CURRENT_LIFESTYLE',
  DESCRIBE_CURRENT_EATING_HABITS: 'DESCRIBE_CURRENT_EATING_HABITS',
  TAKE_WEIGHT_LOSS_MEDICATION_BEFORE: 'TAKE_WEIGHT_LOSS_MEDICATION_BEFORE',
  DID_MEDICATION_WORK: 'DID_MEDICATION_WORK',
  METABOLIC_ASSESSMENT: 'METABOLIC_ASSESSMENT',
  DOCTOR_ASSESSMENT: 'DOCTOR_ASSESSMENT',
  APPOINTMENT_PREFERENCES: 'APPOINTMENT_PREFERENCES',
  YOUR_TEST_PACKAGE: 'YOUR_TEST_PACKAGE',
  OTHER_CONDITION_OR_MEDICAL_HISTORY: 'OTHER_CONDITION_OR_MEDICAL_HISTORY',
  DOCTOR_CONSULTATION_GLP: 'DOCTOR_CONSULTATION_GLP',
  DOCTOR_CONSULTATION_PILL: 'DOCTOR_CONSULTATION_PILL',
  DOCTOR_CONSULTATION: 'DOCTOR_CONSULTATION',
  PHARMACIST_CONSULTATION: 'PHARMACIST_CONSULTATION',
  PACKAGE_SELECTION: 'PACKAGE_SELECTION',
  RYBELSUS_PACKAGE_SELECTION: 'RYBELSUS_PACKAGE_SELECTION',
  PANBESY_PACKAGE_SELECTION: 'PANBESY_PACKAGE_SELECTION',
  PLAN_WEEKLY_MENU: 'PLAN_WEEKLY_MENU',
  MEAL_DELIVERY_TIME: 'MEAL_DELIVERY_TIME',
  DIETICIAN_APPOINTMENT_PREFERENCES: 'DIETICIAN_APPOINTMENT_PREFERENCES',
};

export const WEIGHT_LOSS_TWO_KEYS: Record<WeightLossTwoKeys, WeightLossTwoKeys> = {
  START: 'START',
  ADDITIONAL_DETAILS: 'ADDITIONAL_DETAILS',
  OBESITY_CHECK: 'OBESITY_CHECK',
  SYMPTOMS_CHECK: 'SYMPTOMS_CHECK',
  CURRENT_LIFESTYLE: 'CURRENT_LIFESTYLE',
  EATING_HABITS: 'EATING_HABITS',
  TAKE_WEIGHT_LOSS_MEDICATION_BEFORE: 'TAKE_WEIGHT_LOSS_MEDICATION_BEFORE',
  DID_MEDICATION_WORK: 'DID_MEDICATION_WORK',
  MEDICAL_HISTORY: 'MEDICAL_HISTORY',
  THANK_YOU: 'THANK_YOU',
};

export const WEIGHT_LOSS_RENEWAL_KEYS: Record<WeightLossRenewalKeys, WeightLossRenewalKeys> = {
  START: 'START',
  ADDITIONAL_INFORMATION: 'ADDITIONAL_INFORMATION',
  DID_MEDICATION_WORK: 'DID_MEDICATION_WORK',
  SYMPTOMS_CHECK: 'SYMPTOMS_CHECK',
  WHATS_NEXT: 'WHATS_NEXT',
};

export const TIME_OPTIONS = [
  {
    label: 'Morning',
    value: 'MORNING',
    selected: false,
  },
  {
    label: 'Early PM',
    value: 'EARLY_PM',
    selected: false,
  },
  {
    label: 'Late PM',
    value: 'LATE_PM',
    selected: false,
  },
];

export const WEIGHT_LOSS_ONE_QUESTIONNAIRES: Questionnaire[] = [
  {
    key: WEIGHT_LOSS_KEYS.START,
    index: 'SCREEN_1',
    title: 'MDQ1 - Welcome To Elevate',
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    descriptions: {
      default: [],
    },
    questions: {
      default: 'Welcome to Elevate',
      description: `To discover which Elevate service is right for you, we'll start with some questions. All of your responses are kept private and confidential`,
      estimateTime: '2-3 mins',
    },
    careTeam: {
      images: [doctor1, doctor2, doctor3],
      title: 'Your Care Team',
      description: 'Qualified Singaporean doctors, pharmacists and care navigators',
    },
  },
  {
    key: WEIGHT_LOSS_KEYS.HOW_IT_WORK,
    index: 'SCREEN_2',
    title: 'MDQ1 - How it works',
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    descriptions: {
      default: [],
    },
    questions: {
      default: 'How it works',
    },
    userReviews: [
      {
        userName: 'Debra',
        star: 5,
        content: `Dr Jody and the team have been exceptional. They provided thorough answers to my questions, making the entire process incredibly convenient. Since I began using the Saxenda pens sometime in June, I've witnessed a reduction in my weight, going from approximately 66kg to 57-58kg.`,
      },
      {
        userName: 'Vee',
        star: 5,
        content: `I've struggled to lose weight for months, but this weight loss program has helped me achieve it! Using Saxenda along with a healthy diet and minimal exercise helped me lose 4 kg in just 3 weeks! My journey has been made much easier by the Doctor and the team's assistance, knowledge, and friendliness.`,
      },
      {
        userName: 'Eli',
        star: 5,
        content: `This medication changed my life. After menopause it was very difficult for me to lose weight. Nothing seemed to work. I couldn’t recognise myself or my body anymore. Since trying this medication I’ve regained my confidence. I feel happier & healthier than ever.`,
      },
    ],
    howItWorks: [
      {
        image: howItWorks1,
        title: '1. Initial screening',
        description: 'Answer some questions, get advice from our team and find out what treatments suit you',
      },
      {
        image: howItWorks2,
        title: '2. Doctor consultation',
        description: 'Attend a video consultation with your doctor to discuss your treatment.',
      },
      {
        image: howItWorks3,
        title: '3. Medical assessment',
        description: 'If needed, attend a health screening for us to find the program best suited for you',
      },
      {
        image: howItWorks4,
        title: '4. Treatment delivery',
        description: 'Free, discreet delivery of everything you need to get started.',
      },
    ],
  },
  {
    key: WEIGHT_LOSS_KEYS.PROFILE,
    index: 'SCREEN_3',
    title: `MDQ1 - User's details`,
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    descriptions: {
      default: [],
    },
    questions: {
      default: 'Please enter your details',
    },
    checkoutStep: 1,
  },
  {
    key: WEIGHT_LOSS_KEYS.INVALID,
    index: 'SCREEN_4',
    title: 'MDQ1 - Age & Gender Block',
    actions: [
      {
        label: 'Exit',
        value: 'EXIT_INVALID',
        userAction: {
          value: 'EXIT_INVALID',
          params: null,
        },
      },
    ],
    descriptions: {
      default: [
        'We are not permitted to provide this service to those below 18, or anyone obtaining medication on behalf of someone else.',
        'If your partner, friend or relative needs to use our services, please have them create an account or reach out to us.',
      ],
    },
    questions: {
      default: 'We’re sorry',
    },

    checkoutStep: 1,
  },
  {
    key: WEIGHT_LOSS_KEYS.HOW_DID_YOU_HEAR_ABOUT_US,
    index: 'SCREEN_5',
    title: 'MDQ1 - How did you hear',
    checkoutStep: 1,
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    descriptions: {
      default: [],
    },
    questions: {
      default: 'How did you hear about us?',
      description: 'Select as many as apply to you',
    },
    options: [
      {
        label: 'Google',
        value: 'GOOGLE',
        key: 'GOOGLE',
      },
      {
        label: 'Facebook',
        value: 'FACEBOOK',
        key: 'FACEBOOK',
      },
      {
        label: 'Youtube',
        value: 'YOUTUBE',
        key: 'YOUTUBE',
      },
      {
        label: 'Email',
        value: 'EMAIL',
        key: 'EMAIL',
      },
      {
        label: 'Tiktok',
        value: 'TIKTOK',
        key: 'TIKTOK',
      },
      {
        label: 'Instagram',
        value: 'INSTAGRAM',
        key: 'INSTAGRAM',
      },
      {
        label: 'Through a friend',
        value: 'FRIEND',
        key: 'FRIEND',
      },
      {
        label: 'News or online article',
        value: 'NEWS',
        key: 'NEWS',
      },
      {
        label: 'None of the above',
        value: 'NONE',
        key: 'NONE',
      },
    ],
  },
  {
    key: WEIGHT_LOSS_KEYS.BMI_CALCULATOR,
    index: 'SCREEN_6',
    title: 'MDQ1 - BMI Calculation',
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    checkoutStep: 1,
    descriptions: {
      default: [],
    },
    questions: {
      default: 'What is your height?',
      sub: 'What is your weight?',
    },
  },
  {
    key: WEIGHT_LOSS_KEYS.PROGRAM_SELECTION,
    index: 'SCREEN_7_NEW',
    title: 'MDQ1 - Program Selection',
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    checkoutStep: 1,
    descriptions: {
      default: [],
    },
    questions: {
      default: 'Based on your BMI, the following may be suitable for you for [bold]weight loss[/bold]',
      sub: 'Don’t worry, your doctor will review if this is the right treatment for you',
      sub2: 'Not sure what to choose?',
      sub3: '* please note that all prescription medications are subject to doctor review and approval',
    },
    programs: [
      {
        label: WL_PROGRAMS.ELEVATE_SAXENDA.label,
        value: WL_PROGRAMS.ELEVATE_SAXENDA.value,
        localValue: WL_PROGRAMS.ELEVATE_SAXENDA.localValue,
        description: 'Prescription injectable medication approved by FDA for weight loss.',
        price: 99,
        pricePrefix: '$',
        priceSuffix: 'pen',
        image: saxenda,
        range: [26.5, Infinity],
        type: 'medication',
        hidePrice: true,
      },
      {
        label: WL_PROGRAMS.ELEVATE_RYBELSUS.label,
        value: WL_PROGRAMS.ELEVATE_RYBELSUS.value,
        localValue: WL_PROGRAMS.ELEVATE_RYBELSUS.localValue,
        description: 'A daily pill that emulates the effects of the GLP-1 hormone.',
        price: 7,
        pricePrefix: '$',
        priceSuffix: 'pill',
        image: rybelsus,
        range: [25.5, Infinity],
        type: 'medication',
        hidePrice: true,
      },
      {
        label: WL_PROGRAMS.ELEVATE_PANBESY.label,
        value: WL_PROGRAMS.ELEVATE_PANBESY.value,
        localValue: WL_PROGRAMS.ELEVATE_PANBESY.localValue,
        description:
          'A daily tablet for obesity management which suppresses appetite via central nervous system stimulation.',
        price: 1.8,
        pricePrefix: '$',
        priceSuffix: 'pill',
        image: panbesy,
        range: [25.5, Infinity],
        type: 'medication',
        hidePrice: true,
      },
      {
        label: WL_PROGRAMS.ELEVATE_NUTRITION_PROGRAM.label,
        value: WL_PROGRAMS.ELEVATE_NUTRITION_PROGRAM.value,
        localValue: WL_PROGRAMS.ELEVATE_NUTRITION_PROGRAM.localValue,
        description:
          'Dietitian-led nutrition program with pre-made meals delivered to your home that can help you lose up to 4-5kgs per month.',
        image: supplement,
        tags: ['Nutrition Program'],
        range: [0, Infinity],
        type: 'program',
      },
      {
        label: WL_PROGRAMS.ELEVATE_CGM_PROGRAM.label,
        value: WL_PROGRAMS.ELEVATE_CGM_PROGRAM.value,
        localValue: WL_PROGRAMS.ELEVATE_CGM_PROGRAM.localValue,
        description:
          'Lose up to 10% body weight in a year with device-based glucose monitoring combined with ongoing health coaching',
        image: cgm,
        tags: ['Daily Glucose Monitoring'],
        range: [0, 25.49],
        type: 'program',
      },
      {
        label: WL_PROGRAMS.ELEVATE_SUPPLEMENT_PROGRAM.label,
        value: WL_PROGRAMS.ELEVATE_SUPPLEMENT_PROGRAM.value,
        localValue: WL_PROGRAMS.ELEVATE_SUPPLEMENT_PROGRAM.localValue,
        description:
          'Lose weight with our personalized, pharmacist-led supplement program, catered to your budget, needs & goals',
        image: supplement,
        tags: ['Supplement Program'],
        range: [0, 25.49],
        type: 'program',
      },
    ],
  },
  {
    key: WEIGHT_LOSS_KEYS.BMI_UNDERWEIGHT,
    index: 'SCREEN_6A',
    title: 'MDQ1 - Underweight Block',
    actions: [
      {
        label: 'Speak with care team',
        value: 'SPEAK_WITH_CARE_TEAM',
        userAction: {
          value: 'SPEAK_WITH_CARE_TEAM',
          params: null,
        },
      },
      {
        label: 'Exit',
        value: 'EXIT',
        userAction: {
          value: 'EXIT',
          params: null,
        },
      },
    ],
    descriptions: {
      default: [
        'Which is considered b!underweight. Consider changing your diet or lifestyle in order to maintain a healthy BMI (between 18.5 to 27.0). Being underweight can cause you to be susceptible to nutritional deficiency and other issues.',
        'If you’d still like to speak with a doctor for advice on diet or weight related issues, you may still do so by speaking with our care team, who can connect you with one of our doctors.',
      ],
    },
    questions: {
      default: 'Oops! This service might not be suitable for you',
      sub: 'The treatments offered through this service are only suitable for people who have a BMI of 27 and above.',
    },
  },
  {
    key: WEIGHT_LOSS_KEYS.BMI_HEALTHY_BLOCK,
    index: 'SCREEN_6B',
    title: 'MDQ1 - Healthy Block',
    actions: [
      {
        label: 'Speak with care team',
        value: 'SPEAK_WITH_CARE_TEAM',
        userAction: {
          value: 'SPEAK_WITH_CARE_TEAM',
          params: null,
        },
      },
      {
        label: 'Exit',
        value: 'EXIT',
        userAction: {
          value: 'EXIT',
          params: null,
        },
      },
    ],
    descriptions: {
      default: [
        'Which is considered b!healthy. If you’d still like to lose weight, consider lifestyle and diet changes.',
        'If you’d still like to speak with a doctor for advice on diet or weight related issues, you may still do so by speaking with our care team, who can connect you with one of our doctors.',
      ],
    },
    questions: {
      default: 'Oops! This service might not be suitable for you',
      sub: 'The treatments offered through this service are only suitable for people who have a BMI of 27 and above.',
    },
  },
  {
    key: WEIGHT_LOSS_KEYS.FOLLOWING_APPLY,
    index: 'SCREEN_7',
    title: 'MDQ1 - Symptoms Check',
    checkoutStep: 1,
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    descriptions: {
      default: [],
    },
    questions: {
      default: 'Do any of the following apply for you?',
      description: 'Select as many options that apply to you',
    },
    options: [
      {
        label: 'You are breastfeeding',
        value: 'BREASTFEEDING',
        key: 'BREASTFEEDING',
      },
      {
        label: 'You are pregnant',
        value: 'PREGNANT',
        key: 'PREGNANT',
      },
      {
        label: 'You are trying to become pregnant',
        value: 'TRYING_TO_BECOME_PREGNANT',
        key: 'TRYING_TO_BECOME_PREGNANT',
      },
      {
        label: 'You are allergic to Semaglutide or Liraglutide',
        value: 'ALLERGIC_TO_SEMAGLUTIDE_OR_LIRAGLUTIDE',
        key: 'ALLERGIC_TO_SEMAGLUTIDE_OR_LIRAGLUTIDE',
      },
      {
        label: 'None of the above',
        value: 'NONE',
        key: 'NONE',
      },
    ],
  },
  {
    key: WEIGHT_LOSS_KEYS.BMI_ALLERGIC,
    index: 'SCREEN_7A',
    title: 'MDQ 1 - Symptoms Block',
    actions: [
      {
        label: 'Return to program selection',
        value: 'RETURN_TO_PROGRAM_SELECTION',
        userAction: {
          value: 'RETURN_TO_PROGRAM_SELECTION',
          params: null,
        },
      },
    ],
    descriptions: {
      default: [
        'However, we do have alternative treatment options that could work for you. Return to the program selection page to learn more.',
      ],
    },
    questions: {
      default: 'might not be suitable for you',
      sub: 'is not a suitable medication for you as you have indicated that:',
    },
  },
  {
    key: WEIGHT_LOSS_KEYS.COULD_WORK_FOR_YOU,
    index: 'SCREEN_8',
    title: 'MDQ1 - Great news',
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    checkoutStep: 1,
    descriptions: {
      sub: 'What’s included',
      default: [
        '[bold]In-depth consultations[/bold] with certified Singapore doctors throughout the program, including before, during and upon completion.',
        '[bold]Access to medication[/bold] tailored to your biology and weight goals, with [bold]free delivery[/bold] to your home.',
        '[bold]Community[/bold] that helps you connect with other members going on the same journey as you.',
        '[bold]Ongoing 1:1 medical provider & care team support[/bold] to assist you throughout the program.',
      ],
    },
    questions: {
      default: 'Great news! The Elevate Program could work for you',
      description: 'Your answers indicate that you could be suitable for the Elevate Program.',
    },
  },
  {
    key: WEIGHT_LOSS_KEYS.COULD_WORK_FOR_YOU_GLP,
    index: 'SCREEN_8_GLP',
    title: 'MDQ1 - Great news (GLP-1)',
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    checkoutStep: 1,
    descriptions: {
      sub: 'What’s included',
      default: [
        '[bold]In-depth consultations[/bold] with certified Singapore doctors throughout the program, including before, during and upon completion.',
        '[bold]Access to medication[/bold] tailored to your biology and weight goals, with [bold]free delivery[/bold] to your home.',
        '[bold]Ongoing 1:1 medical provider & care team chat support[/bold] to assist you throughout the program.',
      ],
    },
    optional: {
      title: 'Optional add-ons',
      description: [
        '[bold]Nutritional guidance[/bold] by qualified nutritionists to support your overall weight loss goals.',
        '[bold]Meal replacement[/bold] products selected by our team of pharmacists and nutritionists to aid your diet and weight goals.',
      ],
    },
    questions: {
      default: 'Great news! The Elevate GLP Program could work for you',
      description: 'Your answers indicate that you could be suitable for the Elevate GLP Program.',
    },
  },
  {
    key: WEIGHT_LOSS_KEYS.COULD_WORK_FOR_YOU_PILL,
    index: 'SCREEN_8_PILL',
    title: 'MDQ1 - Great news (Pill)',
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    checkoutStep: 1,
    descriptions: {
      sub: 'What’s included',
      default: [
        '[bold]Access to medication[/bold] tailored to your biology and weight goals, with [bold]free delivery[/bold] to your home.',
        '[bold]Ongoing 1:1 medical provider & care team chat support[/bold] to assist you throughout the program.',
      ],
    },
    optional: {
      title: 'Optional add-ons',
      description: [
        '[bold]Additional consultations[/bold] with certified Singapore doctors throughout the program',
        '[bold]Nutritional guidance[/bold] by qualified nutritionists to support your overall weight loss goals.',
        '[bold]Meal replacement[/bold] products selected by our team of pharmacists and nutritionists to aid your diet and weight goals.',
      ],
    },
    questions: {
      default: 'Great news! The Elevate Pill Program could work for you',
      description: 'Your answers indicate that you could be suitable for the Elevate Pill Program.',
    },
  },
  {
    key: WEIGHT_LOSS_KEYS.COULD_WORK_FOR_YOU_CGM,
    index: 'SCREEN_8_CGM',
    title: 'MDQ1 - Great news (CGM)',
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    checkoutStep: 1,
    descriptions: {
      sub: 'What’s included',
      default: [
        '[bold]Glucose monitoring device[/bold] that helps you monitor your diet and the way your body reacts to certain foods in order to better control consumption and manage your weight, [bold]delivered free[/bold] to your home.',
        '[bold]Bi-weekly[/bold] health coaching teleconsultations with Singapore licensed pharmacists to monitor your progress, provide guidance and ensure that you’re getting the most out of the program.',
        '[bold]Ongoing 1:1 medical provider & care team chat support[/bold] to assist you throughout the program.',
      ],
    },
    optional: {
      title: 'Optional add-ons',
      description: [
        '[bold]Additional consultations[/bold] with certified Singapore doctors throughout the program',
        '[bold]Nutritional guidance[/bold] by qualified nutritionists to support your overall weight loss goals.',
        '[bold]Meal replacement[/bold] products selected by our team of pharmacists and nutritionists to aid your diet and weight goals.',
      ],
    },
    questions: {
      default: 'Great news! The Elevate CGM Program could work for you',
      description: 'Your answers indicate that you could be suitable for the Elevate CGM Program.',
    },
  },
  {
    key: WEIGHT_LOSS_KEYS.COULD_WORK_FOR_YOU_SUPPLEMENTS,
    index: 'SCREEN_8_SUPPLEMENTS',
    title: 'MDQ1 - Great news (Supplements)',
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    checkoutStep: 1,
    descriptions: {
      sub: 'What’s included',
      default: [
        '[bold]Consultations with a Singapore-licensed pharmacist[/bold] to discuss your current situation, health history and personal goals.',
        '[bold]Supplements, devices and meal replacement products[/bold] hand-picked by your pharmacist and tailored to your needs and budget.',
        '[bold]Ongoing 1:1 medical provider & care team chat support[/bold] to assist you throughout the program.',
      ],
    },
    optional: {
      title: 'Optional add-ons',
      description: [
        '[bold]Additional consultations[/bold] with certified Singapore doctors throughout the program',
        '[bold]Nutritional guidance[/bold] by qualified nutritionists to support your overall weight loss goals.',
        '[bold]Meal replacement[/bold] products selected by our team of pharmacists and nutritionists to aid your diet and weight goals.',
      ],
    },
    questions: {
      default: 'Great news! The Elevate Supplement Program could work for you',
      description: 'Your answers indicate that you could be suitable for the Elevate Supplement Program.',
    },
  },
  {
    key: WEIGHT_LOSS_KEYS.NUTRITION_HOW_IT_WORKS,
    index: 'SCREEN_8_NUTRITION',
    title: 'MDQ1 - Nutrition Program - How it works',
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    checkoutStep: 1,
    descriptions: {
      sub: 'Dr Lim Su Lin',
      default: [
        'This diet helps you maintain a net carbohydrate intake of 50g or less a day to induce ketosis, where stored fat (instead of glucose) is broken down to provide energy.',
        'We have collaborated with Dr. Lim and our meal service provider to develop a range of healthy ketogenic and ready-to-eat frozen meals which are calorie-calibrated and curated to keep you full and satisfied between meals.',
        'By combining the meals with [bold]dietitian teleconsultations[/bold], patients can expect rapid and sustainable weight loss.',
      ],
    },
    questions: {
      default: 'How it works',
      description:
        'The Elevate Nutrition program is based on the innovative [bold]Healthy Ketogenic Diet[/bold] concept, developed by [bold]Dr Lim Su Lin[/bold], the [bold]Chief Dietitian[/bold] at the NUH National University Hospital in Singapore.',
    },
  },
  {
    key: WEIGHT_LOSS_KEYS.ELEVATE_PROGRAM_GOALS,
    index: 'SCREEN_9',
    title: 'MDQ1 - Chart',
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    checkoutStep: 1,
    descriptions: {
      sub: 'What’s included',
      default: [
        '[bold]In-depth consultations[/bold] with certified Singapore doctors every 3 months while you continue to remain on Elevate GLP-1 medication.',
        'Easy access to medication, hassle-free refills and [bold]free delivery[/bold] to your home.',
        '[bold]Ongoing 1:1 medical provider & care team chat support[/bold] to assist you throughout the program.',
      ],
    },
    questions: {
      default: 'With [program] you could reach [bold][kg] kg[/bold] in a year',
    },
  },
  {
    key: WEIGHT_LOSS_KEYS.NUTRITION_WHAT_INCLUDED,
    index: 'SCREEN_9_NUTRITION',
    title: 'MDQ1 - Nutrition Program - What’s included',
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    checkoutStep: 1,
    descriptions: {
      default: [],
    },
    questions: {
      default: 'What’s included',
    },
    includeItems: [
      {
        label: 'Prepared Meals',
        key: 'PREPARED_MEALS',
        description:
          'A wide variety of tasty keto meals, delivered weekly, each carefully developed by Dr Su Lin and created in collaboration with a meal delivery provider.',
        subDescription: '...and 12 dishes more',
        showDivider: true,
        items: [
          {
            label: 'Char Kway Teow',
            key: 'CHAR_KWAY_TEOW',
            image: charKwayTeow,
          },
          {
            label: 'Baked Cheesy Pasta',
            key: 'BAKED_CHEESY_PASTA',
            image: bakedChessyPasta,
          },
          {
            label: 'Kimchi Fried Rice',
            key: 'KIMCHI_FRIED_RICE',
            image: kimchiFriedRice,
          },
          {
            label: 'Chicken with Mash',
            key: 'CHICKEN_WITH_MASH',
            image: chickenWithMash,
          },
          {
            label: 'Tom Yum Spaghetti',
            key: 'TOMYUM_SPAGHETTI',
            image: tomYumSpaghetti,
          },
          {
            label: 'Briyani Chicken Tandoori',
            key: 'BRIYANI_CHICKEN_TANDOORI',
            image: briyaniChicken,
          },
        ],
      },
      {
        label: 'Dietitian Coaching',
        key: 'DIETICIAN_COACHING',
        description:
          'Weekly consultations with a Singapore registered dietitian to understand your goals, track your progress and adjust your diet along the way in order to achieve best results.',
      },
    ],
  },
  {
    key: WEIGHT_LOSS_KEYS.NUTRITION_PACKAGE_SELECTION,
    index: 'SCREEN_10_NUTRITION',
    title: 'MDQ1 - Nutrition Package Selection',
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    checkoutStep: 2,
    descriptions: {
      default: [],
    },
    questions: {
      default: 'Select your program duration',
    },
    medProducts: [
      {
        isPopular: false,
        period: '1 week trial',
        periodSuffix: 'week',
        price: 379,
        totalPrice: 379,
        priceSuffix: '',
        includeItems: [
          '2 meals per day for 1 week (14 meals in total)',
          '1 trial online video consultation with dietitian (20-30 mins)',
          '1 phone call with a dietitian (10-15 mins)',
        ],
        sku: 'SG-NT-1',
        potentialWeightLoss: '1 - 1.5 kg',
      },
      {
        isPopular: false,
        period: '4 weeks',
        periodSuffix: 'week',
        price: 365,
        totalPrice: 1459,
        priceSuffix: 'week',
        includeItems: [
          '2 meals per day for 4 weeks (56 meals in total)',
          '1 online video consultation with dietitian (60 mins)',
          '4 phone calls with a dietitian (10-15 mins each)',
        ],
        sku: 'SG-NT-4',
        potentialWeightLoss: '4 - 5 kg',
      },
      {
        isPopular: true,
        period: '8 weeks',
        periodSuffix: 'weeks',
        price: 350,
        totalPrice: 2799,
        priceSuffix: 'week',
        includeItems: [
          '2 meals per day for 8 weeks (112 meals in total)',
          '2 online video consultations with dietitian (60 mins each)',
          '8 phone calls with a dietitian (10-15 mins each)',
        ],
        sku: 'SG-NT-8',
        potentialWeightLoss: '8 - 10 kg',
      },
      {
        isPopular: false,
        period: '12 weeks',
        periodSuffix: 'week',
        price: 347,
        totalPrice: 4159,
        priceSuffix: 'week',
        includeItems: [
          '2 meals per day for 12 weeks (168 meals in total)',
          '3 online video consultations with dietitian (60 mins each)',
          '10 phone calls with a dietitian (10-15 mins each)',
        ],
        sku: 'SG-NT-12',
        potentialWeightLoss: '16 kg',
      },
      {
        isPopular: false,
        period: '16 weeks',
        periodSuffix: 'week',
        price: 338,
        totalPrice: 5399,
        priceSuffix: 'week',
        includeItems: [
          '2 meals per day for 16 weeks (224 meals in total)',
          '4 online video consultations with dietitian (60 mins each)',
          '12 phone calls with a dietitian (10-15 mins each)',
        ],
        sku: 'SG-NT-16',
        potentialWeightLoss: '20 kg',
      },
    ],
  },
  {
    key: WEIGHT_LOSS_KEYS.CGM_PACKAGE_SELECTION,
    index: 'SCREEN_10_CGM',
    title: 'MDQ1 - CGM Package Selection',
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    checkoutStep: 2,
    descriptions: {
      default: [],
    },
    questions: {
      default: 'Select your CGM package',
    },
    medProducts: [
      {
        isPopular: false,
        period: '1 month',
        periodSuffix: 'months',
        price: 300,
        priceSuffix: 'month',
        includeItems: [
          '1 months’ supply of glucose monitoring devices',
          'Total of 2 pharmacist consultations',
          'Ongoing guidance & support',
        ],
        sku: 'SG-O-WLM-CGM1-1',
      },
      {
        isPopular: true,
        period: '3 months',
        periodSuffix: 'months',
        price: 260,
        priceSuffix: 'month',
        includeItems: [
          '3 months’ supply of glucose monitoring devices',
          'Total of 6 pharmacist consultations',
          'Ongoing guidance & support',
        ],
        sku: 'SG-O-WLM-CGM3-1',
      },
      {
        isPopular: false,
        period: '6 months',
        periodSuffix: 'months',
        price: 250,
        priceSuffix: 'month',
        includeItems: [
          '6 months’ supply of glucose monitoring devices',
          'Total of 12 pharmacist consultations',
          'Ongoing guidance & support',
        ],
        sku: 'SG-O-WLM-CGM6-1',
      },
    ],
  },
  {
    key: WEIGHT_LOSS_KEYS.SAXENDA_PACKAGE_SELECTION,
    index: 'SCREEN_10_SAXENDA',
    title: 'MDQ1 - Saxenda Package Selection',
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    checkoutStep: 2,
    descriptions: {
      default: [],
    },
    questions: {
      default: 'Select your package',
    },
    medProducts: [
      {
        isPopular: false,
        period: '1 pen',
        periodSuffix: 'pen',
        price: 130,
        priceSuffix: '+ GST',
        description: 'Select a larger bundle to access interest free payments with Atome.',
        sku: 'SG-P-WLM-SAX-1',
      },
      {
        isPopular: false,
        period: '3 pens',
        periodSuffix: 'pen',
        price: 360,
        priceSuffix: '+ GST',
        payLaterPrice: 120,
        description: 'Select a larger bundle to access interest free payments with Atome.',
        sku: 'SG-P-WLM-SAX-3x',
      },
      {
        isPopular: true,
        period: '6 pens',
        periodSuffix: 'pen',
        price: 714,
        priceSuffix: '+ GST',
        payLaterPrice: 119,
        description: 'Pay in 3 easy payments of only $238 + GST per month, 0% interest with ',
        canPayLater: true,
        sku: 'SG-P-WLM-SAX-6',
      },
      {
        isPopular: false,
        period: '9 pens',
        periodSuffix: 'pen',
        price: 1062,
        priceSuffix: '+ GST',
        payLaterPrice: 118,
        description: 'Pay in 3 easy payments of only $354 + GST per month, 0% interest with ',
        canPayLater: true,
        sku: 'SG-P-WLM-SAX-9',
      },
      {
        isPopular: false,
        period: '12 pens',
        periodSuffix: 'pen',
        price: 1380,
        priceSuffix: '+ GST',
        payLaterPrice: 115,
        description: 'Pay in 3 easy payments of only $460 + GST per month, 0% interest with ',
        canPayLater: true,
        sku: 'SG-P-WLM-SAX-12',
      },
      {
        isPopular: false,
        period: '18 pens',
        periodSuffix: 'pen',
        price: 1908,
        priceSuffix: '+ GST',
        payLaterPrice: 106,
        description: 'Pay in 3 easy payments of only $636 + GST per month, 0% interest with ',
        canPayLater: true,
        sku: 'SG-P-WLM-SAX-18',
      },
      {
        isPopular: false,
        period: '27 pens',
        periodSuffix: 'pen',
        price: 2781,
        priceSuffix: '+ GST',
        payLaterPrice: 103,
        description: 'Pay in 3 easy payments of only $927 + GST per month, 0% interest with ',
        canPayLater: true,
        sku: 'SG-P-WLM-SAX-27',
      },
      {
        isPopular: false,
        period: '36 pens',
        periodSuffix: 'pen',
        price: 3564,
        priceSuffix: '+ GST',
        payLaterPrice: 99,
        description: 'Pay in 3 easy payments of only $1,188 + GST per month, 0% interest with ',
        canPayLater: true,
        sku: 'SG-P-WLM-SAX-36',
      },
    ],
  },
  {
    key: WEIGHT_LOSS_KEYS.RYBELSUS_PACKAGE_SELECTION,
    index: 'SCREEN_10_RYBELSUS',
    title: 'MDQ1 - Rybelsus Package Selection',
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    checkoutStep: 2,
    descriptions: {
      default: [],
    },
    questions: {
      default: 'Select your package',
      sub: '30 pills per box',
    },
    options: [
      {
        value: '3mg',
        label: '3mg',
        key: '3mg',
        defaultSelection: true,
        data: [
          {
            isPopular: false,
            period: '1 box',
            periodSuffix: 'box',
            price: 255,
            payLaterPrice: 255,
            priceSuffix: '+ GST',
            description: 'Select a larger bundle to access interest free payments with Atome.',
            sku: 'SG-P-WLM-RYB3-1',
          },
          {
            isPopular: true,
            period: '3 boxes',
            periodSuffix: 'box',
            price: 675,
            priceSuffix: '+ GST',
            payLaterPrice: 225,
            description: 'Select a larger bundle to access interest free payments with',
            canPayLater: true,
            sku: 'SG-P-WLM-RYB3-3',
          },
          {
            isPopular: false,
            period: '6 boxes',
            periodSuffix: 'box',
            price: 1260,
            priceSuffix: '+ GST',
            payLaterPrice: 210,
            description: 'Pay in 3 easy payments of only $420 + GST per month, 0% interest with',
            canPayLater: true,
            sku: 'SG-P-WLM-RYB3-6',
          },
        ],
      },
      {
        value: '7mg',
        label: '7mg',
        key: '7mg',
        defaultSelection: false,
        data: [
          {
            isPopular: false,
            period: '1 box',
            periodSuffix: 'box',
            price: 435,
            payLaterPrice: 435,
            priceSuffix: '+ GST',
            description: 'Select a larger bundle to access interest free payments with Atome.',
            sku: 'SG-P-WLM-RYB7-1',
          },
          {
            isPopular: true,
            period: '3 boxes',
            periodSuffix: 'box',
            price: 1125,
            priceSuffix: '+ GST',
            payLaterPrice: 375,
            description: 'Pay in 3 easy payments of only $375 + GST per month, 0% interest with',
            canPayLater: true,
            sku: 'SG-P-WLM-RYB7-3',
          },
          {
            isPopular: false,
            period: '6 boxes',
            periodSuffix: 'box',
            price: 2160,
            priceSuffix: '+ GST',
            payLaterPrice: 360,
            description: 'Pay in 3 easy payments of only $720 + GST per month, 0% interest with',
            canPayLater: true,
            sku: 'SG-P-WLM-RYB7-6',
          },
        ],
      },
      {
        value: '14mg',
        label: '14mg',
        key: '14mg',
        data: [
          {
            isPopular: false,
            period: '1 box',
            periodSuffix: 'box',
            price: 435,
            payLaterPrice: 435,
            priceSuffix: '+ GST',
            description: 'Select a larger bundle to access interest free payments with Atome.',
            sku: 'SG-P-WLM-RYB14-1',
          },
          {
            isPopular: true,
            period: '3 boxes',
            periodSuffix: 'box',
            price: 1125,
            priceSuffix: '+ GST',
            payLaterPrice: 375,
            description: 'Pay in 3 easy payments of only $375 + GST per month, 0% interest with',
            canPayLater: true,
            sku: 'SG-P-WLM-RYB14-3',
          },
          {
            isPopular: false,
            period: '6 boxes',
            periodSuffix: 'box',
            price: 2160,
            priceSuffix: '+ GST',
            payLaterPrice: 360,
            description: 'Pay in 3 easy payments of only $720 + GST per month, 0% interest with',
            canPayLater: true,
            sku: 'SG-P-WLM-RYB14-6',
          },
        ],
      },
    ],
  },
  {
    key: WEIGHT_LOSS_KEYS.PANBESY_PACKAGE_SELECTION,
    index: 'SCREEN_10_PANBESY',
    title: 'MDQ1 - Panbesy Package Selection',
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    checkoutStep: 2,
    descriptions: {
      default: [],
    },
    questions: {
      default: 'Select your package',
    },
    options: [
      {
        value: '15mg',
        label: '15mg',
        key: '15mg',
        data: [
          {
            isPopular: false,
            period: '30 pills',
            periodSuffix: 'pill',
            price: 75,
            payLaterPrice: 2.5,
            priceSuffix: '+ GST',
            sku: 'SG-P-WLM-PAN15-30-1',
          },
          {
            isPopular: true,
            period: '90 pills',
            periodSuffix: 'pill',
            price: 180,
            priceSuffix: '+ GST',
            payLaterPrice: 2,
            // canPayLater: true,
            sku: 'SG-P-WLM-PAN15-90-1',
          },
          {
            isPopular: false,
            period: '180 pills',
            periodSuffix: 'pill',
            price: 324,
            priceSuffix: '+ GST',
            payLaterPrice: 1.8,
            // canPayLater: true,
            sku: 'SG-P-WLM-PAN15-180',
          },
        ],
      },
      {
        value: '30mg',
        label: '30mg',
        key: '30mg',
        defaultSelection: true,
        data: [
          {
            isPopular: false,
            period: '30 pills',
            periodSuffix: 'pill',
            price: 90,
            payLaterPrice: 3,
            priceSuffix: '+ GST',
            description: 'Select a larger bundle to access interest free payments with atome',
            sku: 'SG-P-WLM-PAN30-30-1',
          },
          {
            isPopular: true,
            period: '90 pills',
            periodSuffix: 'pill',
            price: 210,
            priceSuffix: '+ GST',
            payLaterPrice: 2.33,
            description: 'Select a larger bundle to access interest free payments with',
            canPayLater: true,
            sku: 'SG-P-WLM-PAN30-90-1',
          },
          {
            isPopular: false,
            period: '180 pills',
            periodSuffix: 'pill',
            price: 390,
            priceSuffix: '+ GST',
            payLaterPrice: 2.17,
            description: 'Pay in 3 easy payments of only $130 + GST per month, 0% interest with',
            canPayLater: true,
            sku: 'SG-P-WLM-PAN30-180',
          },
        ],
      },
    ],
  },
  {
    key: WEIGHT_LOSS_KEYS.PLAN_WEEKLY_MENU,
    index: 'SCREEN_11_NUTRITION',
    title: 'MDQ1 - Nutrition Program - Weekly Menu',
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    checkoutStep: 2,
    descriptions: {
      default: [],
    },
    options: [
      {
        label: 'Char Kway Teow',
        value: 'CHAR_KWAY_TEOW',
        key: 'CHAR_KWAY_TEOW',
        image: charKwayTeow,
      },
      {
        label: 'Baked Cheesy Pasta',
        value: 'BAKED_CHEESY_PASTA',
        key: 'BAKED_CHEESY_PASTA',
        image: bakedChessyPasta,
      },
      {
        label: 'Kimchi Fried Rice',
        value: 'KIMCHI_FRIED_RICE',
        key: 'KIMCHI_FRIED_RICE',
        image: kimchiFriedRice,
      },
      {
        label: 'Korean Japchae',
        value: 'KOERAN_JAPCHAE',
        key: 'KOERAN_JAPCHAE',
        image: koreanJapchae,
      },
      {
        label: 'Sambal Fried Rice',
        value: 'SAMBAL_FRIED_RICE',
        key: 'SAMBAL_FRIED_RICE',
        image: sambalFriedRice,
      },
      {
        label: 'Pad Thai',
        value: 'PAD_THAI',
        key: 'PAD_THAI',
        image: padThai,
      },
      {
        label: 'Shimeji Shiitake Risotto',
        value: 'SHIMEJI_SHIITAKE_RISOTTO',
        key: 'SHIMEJI_SHIITAKE_RISOTTO',
        image: shinemji,
      },
      {
        label: 'Basil Chicken Rice',
        value: 'BASIL_CHICKEN_RICE',
        key: 'BASIL_CHICKEN_RICE',
        image: basilChickenRice,
      },
      {
        label: 'Bolognese Spaghetti',
        value: 'BOLOGNESE_SPAGHETTI',
        key: 'BOLOGNESE_SPAGHETTI',
        image: bolognese,
      },
      {
        label: 'Tom Yum Spaghetti',
        value: 'TOM_YUM_SPAGHETTI',
        key: 'TOM_YUM_SPAGHETTI',
        image: tomYumSpaghetti,
      },
      {
        label: 'Fried Cauliflower Rice',
        value: 'FRIED_CAULIFLOWER_RICE',
        key: 'FRIED_CAULIFLOWER_RICE',
        image: friedCauliflower,
      },
      {
        label: 'Olive Rice',
        value: 'OLIVE_RICE',
        key: 'OLIVE_RICE',
        image: oliveRice,
      },
      {
        label: 'Mushroom Chicken Pasta',
        value: 'MUSHROOM_CHICKEN_PASTA',
        key: 'MUSHROOM_CHICKEN_PASTA',
        image: mushroomChickenPasta,
      },
      {
        label: 'Cottage Pie',
        value: 'COTTAGE_PIE',
        key: 'COTTAGE_PIE',
        image: cottagePie,
      },
      {
        label: 'Briyani Chicken Tandoori',
        value: 'BRIYANI_CHICKEN_TANDOORI',
        key: 'BRIYANI_CHICKEN_TANDOORI',
        image: briyaniChicken,
      },
      {
        label: 'Chicken With Mash',
        value: 'CHICKEN_WITH_MASH',
        key: 'CHICKEN_WITH_MASH',
        image: chickenWithMash,
      },
      {
        label: 'Chicken Bak Chor Mee',
        value: 'CHICKEN_BAK_CHOR_MEE',
        key: 'CHICKEN_BAK_CHOR_MEE',
        image: chickenBarChorMee,
      },
      {
        label: 'Claypot Chicken Rice',
        value: 'CLAYPOT_CHICKEN_RICE',
        key: 'CLAYPOT_CHICKEN_RICE',
        image: claypotChickenRice,
      },
    ],
    questions: {
      default: 'Plan your weekly menu',
      description: 'Choose 7 meals. You may select each meal more than once. All meals are delivered weekly.',
    },
  },
  {
    key: WEIGHT_LOSS_KEYS.DO_YOU_NEED_NEEDLES,
    index: 'SCREEN_11_SAXENDA',
    title: 'MDQ1 - Do you need needles',
    actions: [
      {
        label: 'I do not need these right now ',
        value: 'NEXT_NO_ADD',
        userAction: {
          value: 'NEXT_NO_ADD',
          params: null,
        },
      },
      {
        label: 'Add to cart',
        value: 'NEXT_ADD',
        userAction: {
          value: 'NEXT_ADD',
          params: {
            product: PRODUCT_SKUS.NOVOFINE_NEEDLES,
          },
        },
      },
    ],
    descriptions: {
      default: [
        'You will need NovoFine® needles and alcohol swabs in order to use your Saxenda pens. They cost $49 (w/o GST) and are provided in boxes of 100 units (enough for 3+ months of injections).',
        'If this is your first time purchasing Saxenda, please make sure to add this to your cart.',
        'If you have your own needles / swabs, you can always order these at a later date once you have run out. ',
      ],
    },
    questions: {
      default: 'Do you need NovoFine® needles & alcohol swabs?',
    },

    checkoutStep: 2,
  },
  {
    key: WEIGHT_LOSS_KEYS.WHATS_NEXT_SAXENDA,
    index: 'SCREEN_11_SAXENDA_NEXT',
    title: 'MDQ1 - What’s next (Saxenda)',
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    checkoutStep: 2,
    descriptions: {
      default: [],
    },
    questions: {
      default: 'What’s next?',
      sub: 'Before receiving your medication, you’ll need to attend a  teleconsultation with one of our doctors, who will review your information and approve your treatment. This is required by prevailing health regulations.',
    },
    phasesDescriptions: [
      {
        phaseName: 'Phase 1',
        title: 'Doctor Consultation',
        items: [
          {
            icon: mdqReview,
            description: 'Medical questionnaire reviewed by a doctor',
            key: 'MEDICAL_QUESTIONNAIRE',
          },
          {
            icon: doctorTel,
            description:
              'Teleconsultation with a doctor to discuss your status, goals and guide you on your medication',
            key: 'TELECONSULTATION',
          },
        ],
        payTitle: 'One time payment',
        price: '$20',
      },
      {
        phaseName: 'Phase 2 & 3',
        title: 'Treatment + Care Management',
        items: [
          {
            icon: needleIcon,
            description: 'Saxenda medication prescribed by a doctor',
            key: 'MEDICATION',
          },
          {
            icon: doctorTel,
            description: 'Free doctor teleconsultations to check on progress for every 3-month treatment period',
            key: 'TELECONSULTATION',
          },
          {
            icon: callIcon,
            description: 'Ongoing, unlimited pharmacist support via call or text',
            key: 'PHARMACIST_SUPPORT',
          },
          {
            icon: deliveryIcon,
            description: 'Easy medication refills delivered to you',
            key: 'DELIVERY',
          },
        ],
        payTitle: 'Pay as you go',
        price: '$99',
        pricePrefix: 'from',
        priceSuffix: '/ pen',
        descriptions: [
          'Instalment plans available for purchases above $700.',
          'Exit anytime without charge for undispensed medication.',
        ],
      },
    ],
  },
  {
    key: WEIGHT_LOSS_KEYS.WHATS_NEXT_RYBELSUS,
    index: 'SCREEN_11_RYBELSUS_NEXT',
    title: 'MDQ1 - What’s next (Rybelsus)',
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    checkoutStep: 2,
    descriptions: {
      default: [],
    },
    questions: {
      default: 'What’s next?',
      sub: 'Before receiving your medication, you’ll need to attend a teleconsultation with one of our doctors, who will review your information and approve your treatment. This is required by prevailing health regulations.',
    },
    phasesDescriptions: [
      {
        phaseName: 'Phase 1',
        title: 'Doctor Consultation',
        items: [
          {
            icon: mdqReview,
            description: 'Medical questionnaire reviewed by a doctor',
            key: 'MEDICAL_QUESTIONNAIRE',
          },
          {
            icon: doctorTel,
            description:
              'Teleconsultation with a doctor to discuss your status, goals and guide you on your medication',
            key: 'TELECONSULTATION',
          },
        ],
        payTitle: 'One time payment',
        price: '$20',
      },
      {
        phaseName: 'Phase 2 & 3',
        title: 'Treatment + Care Management',
        items: [
          {
            icon: needleIcon,
            description: 'Rybelsus medication prescribed by a doctor',
            key: 'MEDICATION',
          },
          {
            icon: doctorTel,
            description: 'Free doctor teleconsultations to check on progress for every 3-month treatment period',
            key: 'TELECONSULTATION',
          },
          {
            icon: callIcon,
            description: 'Ongoing, unlimited pharmacist support via call or text',
            key: 'PHARMACIST_SUPPORT',
          },
          {
            icon: deliveryIcon,
            description: 'Easy medication refills delivered to you',
            key: 'DELIVERY',
          },
        ],
        payTitle: 'Pay as you go',
        price: '$210',
        pricePrefix: 'from',
        priceSuffix: '/ box',
        descriptions: [
          'Instalment plans available for purchases above $700.',
          'Exit anytime without charge for undispensed medication.',
        ],
      },
    ],
  },
  {
    key: WEIGHT_LOSS_KEYS.WHATS_NEXT_PANBESY,
    index: 'SCREEN_11_PANBESY_NEXT',
    title: 'MDQ1 - What’s next (Panbesy)',
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    checkoutStep: 2,
    descriptions: {
      default: [],
    },
    questions: {
      default: 'What’s next?',
      sub: 'Before receiving your medication, you’ll need to attend a  teleconsultation with one of our doctors, who will review your information and approve your treatment. This is required by prevailing health regulations.',
    },
    phasesDescriptions: [
      {
        phaseName: 'Phase 1',
        title: 'Doctor Consultation',
        items: [
          {
            icon: mdqReview,
            description: 'Medical questionnaire reviewed by a doctor',
            key: 'MEDICAL_QUESTIONNAIRE',
          },
          {
            icon: doctorTel,
            description:
              'Teleconsultation with a doctor to discuss your status, goals and guide you on your medication',
            key: 'TELECONSULTATION',
          },
        ],
        payTitle: 'One time payment',
        price: '$20',
      },
      {
        phaseName: 'Phase 2 & 3',
        title: 'Treatment + Care Management',
        items: [
          {
            icon: needleIcon,
            description: 'Panbesy medication prescribed by a doctor',
            key: 'MEDICATION',
          },
          {
            icon: doctorTel,
            description: 'Free doctor teleconsultations to check on progress for every 3-month treatment period',
            key: 'TELECONSULTATION',
          },
          {
            icon: callIcon,
            description: 'Ongoing, unlimited pharmacist support via call or text',
            key: 'PHARMACIST_SUPPORT',
          },
          {
            icon: deliveryIcon,
            description: 'Easy medication refills delivered to you',
            key: 'DELIVERY',
          },
        ],
        payTitle: 'Pay as you go',
        price: '$1.80',
        pricePrefix: 'from',
        priceSuffix: '/ pill',
        descriptions: [
          'Instalment plans available for purchases above $700.',
          'Exit anytime without charge for undispensed medication.',
        ],
      },
    ],
  },
  {
    key: WEIGHT_LOSS_KEYS.CGM_ADD_ON_SELECTION,
    index: 'SCREEN_11_CGM',
    title: 'MDQ1 - CGM Add Ons Selection',
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    checkoutStep: 2,
    descriptions: {
      default: [],
    },
    options: [
      {
        label: 'Nutritionist coaching',
        value: 'NUTRITIONIST_COACHING',
        key: 'NUTRITIONIST_COACHING',
      },
      {
        label: 'Doctor consultations',
        value: 'DOCTOR_CONSULTATIONS',
        key: 'DOCTOR_CONSULTATIONS',
      },
      {
        label: 'Meal replacement products',
        value: 'MEAL_REPLACEMENT_PRODUCTS',
        key: 'MEAL_REPLACEMENT_PRODUCTS',
      },
      {
        label: 'Metabolic tests',
        value: 'METABOLIC_TESTS',
        key: 'METABOLIC_TESTS',
      },
    ],
    questions: {
      default: 'Would you be interested in any of these products/services?',
      description:
        'A member of our team will reach out to assist you based on your selection above. You will not be charged for anything at this point.',
    },
  },
  {
    key: WEIGHT_LOSS_KEYS.METABOLIC_ASSESSMENT,
    index: 'SCREEN_10',
    title: 'MDQ1 - Steps Introduction',
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    checkoutStep: 1,
    descriptions: {
      default: [
        `As a next step, you will need to attend a  teleconsultation with one of our doctors, who will assess your suitability for GLP-1 medication, and if not, what other treatments are suitable for you.`,
        `You’ll also have the chance to ask questions and learn more about your health and the treatments we provide`,
        `This video consultation costs $20, and will be carried out at a time of your convenience.`,
      ],
    },
    questions: {
      default: 'Doctor’s consultation',
    },
    stages: [
      {
        key: 'STAGE_1',
        title: 'Stage 1: Assessment',
        description: 'Ensuring you’re suitable for this program.',
        steps: [
          {
            key: 'STEP_1',
            title: 'Medical questionnaire',
            description: 'Answer questions regarding your health history',
          },
          {
            key: 'STEP_2',
            title: 'Doctor consultation',
            description: 'We’ll arrange a metabolic blood test for you to ensure you’re suitable',
          },
          {
            key: 'STEP_3',
            title: 'Metabolic assessment',
            description: 'We’ll arrange a metabolic blood test for you to ensure you’re suitable',
          },
        ],
      },
    ],
  },
  {
    key: WEIGHT_LOSS_KEYS.DOCTOR_CONSULTATION_GLP,
    index: 'SCREEN_10_GLP',
    title: 'MDQ1 - Doctor Consultation GLP-1',
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    checkoutStep: 2,
    descriptions: {
      default: [
        `As a next step, you will need to attend a  teleconsultation with one of our doctors, who will review your questionnaire responses and assess your suitability for GLP-1 medication, and if not, what other treatments are suitable for you.`,
        `You’ll also have the chance to ask questions and learn more about your health, our programs and the treatments we provide.`,
        `This video consultation costs $20, and can be carried out at a time of your convenience.`,
      ],
    },
    questions: {
      default: 'Doctor’s consultation',
    },
    stages: [
      {
        key: 'STAGE_1',
        title: 'Stage 1: Assessment',
        description: 'Ensuring you’re suitable for this program.',
        steps: [
          {
            key: 'STEP_1',
            title: 'Medical questionnaire',
            description: 'Answer questions regarding your health history',
          },
          {
            key: 'STEP_2',
            title: 'Doctor consultation',
            description: 'Speak to a doctor who will discuss your situation and assess your suitability',
          },
          {
            key: 'STEP_3',
            title: 'Medication delivery',
            description:
              'If eligible, we’ll send your medication to your home, together with online coaching & ongoing support',
          },
        ],
      },
    ],
  },
  {
    key: WEIGHT_LOSS_KEYS.DOCTOR_CONSULTATION_PILL,
    index: 'SCREEN_10_PILL',
    title: 'MDQ1 - Doctor Consultation Pill',
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    checkoutStep: 2,
    descriptions: {
      default: [
        `As a next step, you will need to attend a  teleconsultation with one of our doctors, who will review your questionnaire responses and assess which pill-based medication is the most suitable.`,
        `You’ll also have the chance to ask questions and learn more about your health, our programs and the treatments we provide.`,
        `This video consultation costs $20, and can be carried out at a time of your convenience.`,
      ],
    },
    questions: {
      default: 'Doctor’s consultation',
    },
    stages: [
      {
        key: 'STAGE_1',
        title: 'Stage 1: Assessment',
        description: 'Ensuring you’re suitable for this program.',
        steps: [
          {
            key: 'STEP_1',
            title: 'Medical questionnaire',
            description: 'Answer questions regarding your health history',
          },
          {
            key: 'STEP_2',
            title: 'Doctor consultation',
            description: 'Speak to a doctor who will discuss your situation and assess your suitability',
          },
          {
            key: 'STEP_3',
            title: 'Medication delivery',
            description:
              'If eligible, we’ll send your medication to your home, together with online coaching & ongoing support',
          },
        ],
      },
    ],
  },
  {
    key: WEIGHT_LOSS_KEYS.PHARMACIST_CONSULTATION,
    index: 'SCREEN_10_SUPPLEMENTS',
    title: 'MDQ1 - Pharmacist Consultation',
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    checkoutStep: 2,
    descriptions: {
      default: [
        `As a next step, you will need to attend a  teleconsultation with one of our pharmacists, who will review your questionnaire responses and assess which products are the most suitable for you based on your needs and budget.`,
        `We operate a “zero-obligation” policy. You are free to discuss different options with your pharmacist and pick and choose what works for you.`,
        `This video consultation costs $15, and can be carried out at a time of your convenience.`,
      ],
    },
    questions: {
      default: 'Pharmacist consultation',
    },
    stages: [
      {
        key: 'STAGE_1',
        title: 'Stage 1: Assessment',
        description: 'Ensuring you’re suitable for this program.',
        steps: [
          {
            key: 'STEP_1',
            title: 'Medical questionnaire',
            description: 'Answer questions regarding your health history',
          },
          {
            key: 'STEP_2',
            title: 'Pharmacist consultation',
            description: 'Speak to a pharmacist who will discuss your situation and assess your suitability',
          },
          {
            key: 'STEP_3',
            title: 'Product delivery',
            description:
              'We’ll send your supplements or products to your home, together with ongoing support and hassle-free refills.',
          },
        ],
      },
    ],
  },
  {
    key: WEIGHT_LOSS_KEYS.DOCTOR_CONSULTATION,
    index: 'SCREEN_10_DOCTOR',
    title: `MDQ1 - Doctor's Consultation`,
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    checkoutStep: 2,
    descriptions: {
      default: [
        `As a next step, you will need to attend a  teleconsultation with one of our doctors, who will review your questionnaire responses and assess your suitability for the different treatments and medications available on Elevate.`,
        `You’ll also have the chance to ask questions and learn more about your health, our programs and the treatments we provide.`,
        `This video consultation costs $21.8, and can be carried out at a time of your convenience.`,
      ],
      sub: `Please note that prescriptions are not guaranteed. Your eligibility for certain treatments will depend on your current BMI. Your doctor will assess your situation and recommend the treatment best suited for you.`,
    },
    questions: {
      default: `Doctor's consultation`,
    },
  },
  {
    key: WEIGHT_LOSS_KEYS.APPOINTMENT_PREFERENCES,
    index: 'SCREEN_11',
    title: 'MDQ1 - Appointment Preferences',
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    checkoutStep: 2,
    descriptions: {
      default: [],
    },
    questions: {
      default: 'Appointment preferences',
      description: `Our care team will be in touch with you to confirm the exact time of your appointment based on the preferences you provide below`,
      sub: `Preferred location`,
      dayQuestion: `Which days of the week work best for you?`,
      timeQuestion: `Which times during these days work best for you?`,
    },
    options: [
      {
        value: 'AT_HOME',
        label: 'At home',
        relations: [
          {
            elementType: {
              type: 'FORM_INPUT',
            },
            questions: {
              default: 'Please let us know your preferred sample collection location',
            },
          },
        ],
      },
      {
        value: 'IN_CLINIC',
        label: 'In-clinic (Tanjong Pagar)',
        clinicId: 2,
      },
    ],
    dayOptions: [
      {
        value: 'MONDAY',
        label: 'Monday',
        dayOfWeek: 1,
        timeOptions: TIME_OPTIONS,
      },
      {
        value: 'TUESDAY',
        label: 'Tuesday',
        dayOfWeek: 2,
        timeOptions: TIME_OPTIONS,
      },
      {
        value: 'WEDNESDAY',
        label: 'Wednesday',
        dayOfWeek: 3,
        timeOptions: TIME_OPTIONS,
      },
      {
        value: 'THURSDAY',
        label: 'Thursday',
        dayOfWeek: 4,
        timeOptions: TIME_OPTIONS,
      },
      {
        value: 'FRIDAY',
        label: 'Friday',
        dayOfWeek: 5,
        timeOptions: TIME_OPTIONS,
      },
      {
        value: 'SATURDAY',
        label: 'Saturday',
        dayOfWeek: 6,
        timeOptions: TIME_OPTIONS,
      },
      {
        value: 'SUNDAY',
        label: 'Sunday',
        dayOfWeek: 0,
        timeOptions: TIME_OPTIONS,
      },
    ],
  },
  {
    key: WEIGHT_LOSS_KEYS.YOUR_TEST_PACKAGE,
    index: 'SCREEN_12',
    title: 'MDQ 1 - Package Selection',
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    checkoutStep: 2,
    descriptions: {
      default: [],
    },
    questions: {
      default: 'Your test package',
    },
    packages: [
      {
        value: 'METABOLIC_ASSESSMENT',
        label: 'Metabolic assessment',
        price: 75,
        productId: 991,
        prefix: '$',
        suffix: '*',
        promoMessage: '',
        description: `Measures substances in your blood and provides important information about your body's chemical balance and metabolism (i.e. the process of how the body uses food and energy).`,
        type: 'blood test',
        typePrefix: 'Type:',
        howItWorks: `A medical professional will take a blood sample from you at your chosen location (e.g. your home). The entire process should take less than 3 minutes.`,
        includes: [
          {
            label: `Quick results in 7 or less days`,
            key: 'quick_results',
          },
          {
            label: `Includes post-test consultation`,
            key: 'post_test_consultation',
          },
        ],
      },
    ],
  },
  {
    key: WEIGHT_LOSS_KEYS.MEAL_DELIVERY_TIME,
    index: 'SCREEN_12_NUTRITION',
    title: 'MDQ 1 - Meal Delivery Preferences',
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    checkoutStep: 2,
    descriptions: {
      default: [],
    },
    questions: {
      default: 'Meal Delivery Preferences',
      description:
        'When would you like your first meal to be delivered? Future deliveries will take place at the same day and time each week.',
    },
    options: [
      {
        label: '12 - 3 PM',
        value: '12_3_PM',
      },
      {
        label: '3 - 6 PM',
        value: '3_6_PM',
      },
      {
        label: '6 - 9 PM',
        value: '6_9_PM',
      },
    ],
  },
  {
    key: WEIGHT_LOSS_KEYS.DIETICIAN_APPOINTMENT_PREFERENCES,
    index: 'SCREEN_13_NUTRITION',
    title: 'MDQ1 - Dietitian Appointment Preferences',
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    checkoutStep: 2,
    descriptions: {
      default: [],
    },
    questions: {
      default: 'Dietitian Appointment preferences',
      description:
        'Our care team will be in touch with you to confirm the exact time of your first dietitian appointment based on the preferences you provide below',
      dayQuestion: `Which days of the week work best for you?`,
      timeQuestion: `Which times during these days work best for you?`,
    },
    dayOptions: [
      {
        value: 'MONDAY',
        label: 'Monday',
        dayOfWeek: 1,
        timeOptions: TIME_OPTIONS,
      },
      {
        value: 'TUESDAY',
        label: 'Tuesday',
        dayOfWeek: 2,
        timeOptions: TIME_OPTIONS,
      },
      {
        value: 'WEDNESDAY',
        label: 'Wednesday',
        dayOfWeek: 3,
        timeOptions: TIME_OPTIONS,
      },
      {
        value: 'THURSDAY',
        label: 'Thursday',
        dayOfWeek: 4,
        timeOptions: TIME_OPTIONS,
      },
      {
        value: 'FRIDAY',
        label: 'Friday',
        dayOfWeek: 5,
        timeOptions: TIME_OPTIONS,
      },
    ],
  },
];

export const WEIGHT_LOSS_TWO_QUESTIONNAIRES: Questionnaire[] = [
  {
    key: WEIGHT_LOSS_TWO_KEYS.START,
    index: 'SCREEN_1',
    title: 'MDQ2 - Get Started',
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    descriptions: {
      default: [],
    },
    questions: {
      default: 'Let’s get started!',
      description: `Please review your order information before continuing`,
      estimateTime: '2-3 mins',
    },
    userReviews: [
      {
        userName: 'Debra',
        star: 5,
        content: `Dr Jody and the team have been exceptional. They provided thorough answers to my questions, making the entire process incredibly convenient. Since I began using the Saxenda pens sometime in June, I've witnessed a reduction in my weight, going from approximately 66kg to 57-58kg.`,
      },
      {
        userName: 'Vee',
        star: 5,
        content: `I've struggled to lose weight for months, but this weight loss program has helped me achieve it! Using Saxenda along with a healthy diet and minimal exercise helped me lose 4 kg in just 3 weeks! My journey has been made much easier by the Doctor and the team's assistance, knowledge, and friendliness.`,
      },
      {
        userName: 'Eli',
        star: 5,
        content: `This medication changed my life. After menopause it was very difficult for me to lose weight. Nothing seemed to work. I couldn’t recognise myself or my body anymore. Since trying this medication I’ve regained my confidence. I feel happier & healthier than ever.`,
      },
    ],
  },
  {
    key: WEIGHT_LOSS_TWO_KEYS.ADDITIONAL_DETAILS,
    index: 'SCREEN_2',
    title: `MDQ2 - User's details`,
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    descriptions: {
      default: [],
    },
    questions: {
      default: 'Additional details',
      sub: 'We need this information for verification purposes during your appointment',
    },
  },
  {
    key: WEIGHT_LOSS_TWO_KEYS.OBESITY_CHECK,
    index: 'SCREEN_3',
    title: 'MDQ2 - Obesity Check',
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    descriptions: {
      default: [],
    },
    questions: {
      default: 'Do you have any of the following obesity-related conditions?',
      description: 'Select as many as apply to you',
    },
    options: [
      {
        label: 'High blood pressure',
        value: 'HIGH_BLOOD_PRESSURE',
        key: 'HIGH_BLOOD_PRESSURE',
      },
      {
        label: 'High cholesterol',
        value: 'HIGH_CHOLESTEROL',
        key: 'HIGH_CHOLESTEROL',
      },
      {
        label: 'Osteoarthritis',
        value: 'OSTEOARTHRITIS',
        key: 'OSTEOARTHRITIS',
      },
      {
        label: 'Difficulty breathing',
        value: 'DIFFICULTY_BREATHING',
        key: 'DIFFICULTY_BREATHING',
      },
      {
        label: 'Depression',
        value: 'DEPRESSION',
        key: 'DEPRESSION',
      },
      {
        label: 'Body pain',
        value: 'BODY_PAIN',
        key: 'BODY_PAIN',
      },
      {
        label: 'Mobility issues',
        value: 'MOBILITY_ISSUES',
        key: 'MOBILITY_ISSUES',
      },
      {
        label: 'Heart disease',
        value: 'HEART_DISEASE',
        key: 'HEART_DISEASE',
      },
      {
        label: 'Gallbladder disease',
        value: 'GALLBLADDER_DISEASE',
        key: 'GALLBLADDER_DISEASE',
      },
      {
        label: 'Sleep apnea',
        value: 'SLEEP_APNEA',
        key: 'SLEEP_APNEA',
      },
      {
        label: 'Fatty liver disease',
        value: 'FATTY_LIVER_DISEASE',
        key: 'FATTY_LIVER_DISEASE',
      },
      {
        label: 'None of the above',
        value: 'NONE',
        key: 'NONE',
      },
    ],
  },
  {
    key: WEIGHT_LOSS_TWO_KEYS.SYMPTOMS_CHECK,
    index: 'SCREEN_4',
    title: 'MDQ2 - Symptoms Check',
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    descriptions: {
      default: [],
    },
    questions: {
      default: 'Do any of the following apply for you?',
      description: 'Select as many as apply to you',
    },
    options: [
      {
        label: 'You or any of your family has had medullary thyroid cancer',
        value: 'MEDULLARY_THYROID_CANCER',
        key: 'MEDULLARY_THYROID_CANCER',
      },
      {
        label: 'You’ve had an allergic reaction to liraglutide',
        value: 'ALLERGIC_REACTION_TO_LIRAGLUTIDE',
        key: 'ALLERGIC_REACTION_TO_LIRAGLUTIDE',
      },
      {
        label: 'You’re pregnant',
        value: 'PREGNANT',
        key: 'PREGNANT',
      },
      {
        label: 'You plan to become pregnant',
        value: 'PLAN_TO_BECOME_PREGNANT',
        key: 'PLAN_TO_BECOME_PREGNANT',
      },
      {
        label: 'You have MEN2',
        value: 'MEN2',
        key: 'MEN2',
      },
      {
        label: 'None of the above',
        value: 'NONE',
        key: 'NONE',
      },
    ],
  },
  {
    key: WEIGHT_LOSS_TWO_KEYS.CURRENT_LIFESTYLE,
    index: 'SCREEN_5',
    title: 'MDQ2 - Current Lifestyle',
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    descriptions: {
      default: [],
    },
    questions: {
      default: 'How would you describe your current lifestyle?',
    },
    options: [
      {
        label: 'Sedentary',
        value: 'SEDENTARY',
        key: 'SEDENTARY',
        description: `Your spend less than 30 minutes a day on physical activities such as walking, with no moderate or vigorous activity. You also spend most of the day sitting (e.g. at a desk).`,
      },
      {
        label: 'Lightly active',
        value: 'LIGHTLY_ACTIVE',
        key: 'LIGHTLY_ACTIVE',
        description: `Every day, you spend between 30 - 90 minutes on physical activities such as walking, or carry out 15-20 minutes of vigorous activity such as jogging. This would typically burn around 130 - 160 calories for an average adult.`,
      },
      {
        label: 'Active',
        value: 'ACTIVE',
        key: 'ACTIVE',
        description: `Every day, you spend between 90 - 120 minutes a day on physical activities such as walking, or carry out 50 minutes of vigorous activity such as jogging.  This would typically burn around 450 - 600 calories for an average adult.`,
      },
      {
        label: 'Very active',
        value: 'VERY_ACTIVE',
        key: 'VERY_ACTIVE',
        description: `Every day, you spend over 4 hours on physical activities such as walking, or carry out 2 or more hours of vigorous activities such as jogging.  This would typically burn around 1,100 - 1,400 calories for an average adult.`,
      },
    ],
  },
  {
    key: WEIGHT_LOSS_TWO_KEYS.EATING_HABITS,
    index: 'SCREEN_6',
    title: 'MDQ2 - Eating Habits',
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    descriptions: {
      default: [],
    },
    questions: {
      default: 'How would you describe your current eating habits?',
    },
    options: [
      {
        label: 'I do not pay attention to my diet at all',
        value: 'DO_NOT_PAY_ATTENTION',
        key: 'DO_NOT_PAY_ATTENTION',
      },
      {
        label: 'I pay attention to my diet somewhat and avoid unhealthy eating, but only sometimes',
        value: 'PAY_ATTENTION_SOMEWHAT',
        key: 'PAY_ATTENTION_SOMEWHAT',
      },
      {
        label: 'I pay close attention to my diet and monitor my food intake closely, avoiding unhealthy foods',
        value: 'PAY_ATTENTION_CLOSELY',
        key: 'PAY_ATTENTION_CLOSELY',
      },
      {
        label: 'I am on a strict dieting regime and rarely, if ever, eat unhealthily',
        value: 'STRICT_DIETING_REGIME',
        key: 'STRICT_DIETING_REGIME',
      },
    ],
  },
  {
    key: WEIGHT_LOSS_TWO_KEYS.TAKE_WEIGHT_LOSS_MEDICATION_BEFORE,
    index: 'SCREEN_7',
    title: 'MDQ2 - Weight Loss Medication Before',
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    descriptions: {
      default: [],
    },
    questions: {
      default: 'Have you taken any weight loss medication before?',
      sub: 'Which medication(s) did you take?',
      sub2: 'How long did you take them?',
    },
    options: [
      {
        label: 'Yes',
        value: YES_NO_VALUES.YES,
        key: 'YES',
      },
      {
        label: 'No',
        value: YES_NO_VALUES.NO,
        key: 'NO',
      },
    ],
  },
  {
    key: WEIGHT_LOSS_TWO_KEYS.DID_MEDICATION_WORK,
    index: 'SCREEN_8',
    title: 'MDQ2 - Did Medication Work',
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    descriptions: {
      default: [],
    },
    questions: {
      default: 'Did the medication(s) work?',
      sub: 'How much weight did you lose?',
      sub2: 'Did you experience any side effects?',
      sub3: 'What side effects did you experience?',
    },
    options: [
      {
        label: 'Yes',
        value: YES_NO_VALUES.YES,
        key: 'YES',
      },
      {
        label: 'No',
        value: YES_NO_VALUES.NO,
        key: 'NO',
      },
    ],
    subOptions: [
      {
        label: 'Yes',
        value: YES_NO_VALUES.YES,
        key: 'YES',
      },
      {
        label: 'No',
        value: YES_NO_VALUES.NO,
        key: 'NO',
      },
    ],
  },
  {
    key: WEIGHT_LOSS_TWO_KEYS.MEDICAL_HISTORY,
    index: 'SCREEN_9',
    title: 'MDQ2 - Medical History',
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    descriptions: {
      default: [
        `For example, if you had surgery recently, or a  diagnosed medical condition. Or if you’ve had a similar condition in the past, especially if it led to complications.`,
      ],
    },
    questions: {
      default: 'Is there anything else we should know about your condition or medical history?',
      sub: 'Tell us more',
    },
    options: [
      {
        label: 'Yes',
        value: YES_NO_VALUES.YES,
        key: 'YES',
      },
      {
        label: 'No',
        value: YES_NO_VALUES.NO,
        key: 'NO',
      },
    ],
  },
  {
    key: WEIGHT_LOSS_TWO_KEYS.THANK_YOU,
    index: 'SCREEN_10',
    title: 'MDQ2 - Thank You',
    actions: [],
    descriptions: {
      default: [`Our team will be in touch shortly if we need any additional information from you`],
    },
    questions: {
      default: 'Thank you for your responses',
    },
  },
];

export const WEIGHT_LOSS_RENEWAL_QUESTIONNAIRES: Questionnaire[] = [
  {
    key: WEIGHT_LOSS_RENEWAL_KEYS.START,
    index: 'SCREEN_1',
    title: 'MDQ Renewal - Get Started',
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    descriptions: {
      default: [],
    },
    questions: {
      default: 'Let’s get started!',
      description: `This form helps us to collect important information about your treatment progress in order to provide you the best care possible.`,
      sub: 'Please make sure to fill it up on time!',
      estimateTime: '2-3 mins',
    },
    careTeam: {
      images: [doctor1, doctor2, doctor3],
      title: 'Your Care Team',
      description: 'Qualified Singaporean doctors, pharmacists and care navigators',
    },
  },
  {
    key: WEIGHT_LOSS_RENEWAL_KEYS.ADDITIONAL_INFORMATION,
    index: 'SCREEN_2',
    title: `MDQ Renewal - Additional Information`,
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    descriptions: {
      default: [],
    },
    questions: {
      default: 'Additional information',
      sub: 'We require this information to verify details during the renewal process.',
      sub2: 'What is your height?',
      sub3: 'What is your weight?',
      sub4: 'Date of your measurement?',
    },
  },
  {
    key: WEIGHT_LOSS_RENEWAL_KEYS.DID_MEDICATION_WORK,
    index: 'SCREEN_3',
    title: 'MDQ Renewal - Did Medication Work',
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    descriptions: {
      default: [],
    },
    questions: {
      default: 'Did the medication(s) work?',
      sub: 'How much weight did you lose?',
      sub2: 'Did you experience any side effects?',
      sub3: 'What side effects did you experience?',
    },
    options: [
      {
        label: 'Yes',
        value: YES_NO_VALUES.YES,
        key: 'YES',
      },
      {
        label: 'No',
        value: YES_NO_VALUES.NO,
        key: 'NO',
      },
    ],
    subOptions: [
      {
        label: 'Yes',
        value: YES_NO_VALUES.YES,
        key: 'YES',
      },
      {
        label: 'No',
        value: YES_NO_VALUES.NO,
        key: 'NO',
      },
    ],
  },
  {
    key: WEIGHT_LOSS_RENEWAL_KEYS.SYMPTOMS_CHECK,
    index: 'SCREEN_4',
    title: 'MDQ Renewal - Symptoms Check',
    actions: [
      {
        label: 'Continue',
        value: 'NEXT',
        userAction: {
          value: 'NEXT',
          params: null,
        },
      },
    ],
    descriptions: {
      default: [
        `Please note that the above question is only for non-serious treatment-related observations. If you are experiencing severe symptoms or feeling unwell, please seek medical attention immediately.`,
      ],
    },
    questions: {
      default: 'Have you experienced any abnormal signs or symptoms?',
      sub: 'Tell us more',
    },
    options: [
      {
        label: 'Yes',
        value: YES_NO_VALUES.YES,
        key: 'YES',
      },
      {
        label: 'No',
        value: YES_NO_VALUES.NO,
        key: 'NO',
      },
    ],
  },
  {
    key: WEIGHT_LOSS_RENEWAL_KEYS.WHATS_NEXT,
    index: 'SCREEN_5',
    title: 'MDQ Renewal - What’s next',
    actions: [],
    descriptions: {
      default: [`To continue with your purchase, press the button below to added your prescribed medication to cart:`],
    },
    questions: {
      default: 'What’s next',
    },
  },
];
